/* eslint-disable jsx-a11y/label-has-associated-control */
import { SetStateAction, useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Divider, Input, Popconfirm } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

import Swal from "sweetalert2";
import Meta from "antd/lib/card/Meta";

import MobileLayout from "../../../components/MobileLayout";
import { useProfiles } from "../../../hooks/profile";
import { useAuth } from "../../../hooks/auth";
import { useModulos, DataTypeModule } from "../../../hooks/module";
import { Main } from "./styles";

function Modules() {
  const { getAll } = useProfiles();
  const navigate = useNavigate();
  const { getModules, removeModule } = useModulos();
  const [busca, setBusca] = useState("");
  const [data, setData] = useState<DataTypeModule[]>([]);

  const { user } = useAuth();

  useEffect(() => {
    async function loadData() {
      if (!user?.uid) return;
      try {
        await getAll(user.uid);
      } catch (error) {
        navigate("/");
      }
    }
    loadData();
  }, [getAll, navigate, user?.uid]);

  const ListagemDeModulos = useCallback(async () => {
    try {
      const getListaDeModulos = await getModules();
      setData(getListaDeModulos);
    } catch (e) {
      console.log(e);
    }
  }, [getModules]);

  useEffect(() => {
    ListagemDeModulos();
  }, [ListagemDeModulos]);

  async function deleteModule(uid: string) {
    try {
      Swal.fire({
        title: "Deletando...",
        showConfirmButton: false,
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: async () => {
          Swal.showLoading();
          await removeModule(uid);
          await ListagemDeModulos();
          Swal.close();
        },
      });

      ListagemDeModulos();
    } catch (error) {
      throw new Error("Houve um erro inesperado");
    }
  }
  const modulesWithSearch = data.filter((current: DataTypeModule): boolean => {
    return current.title.toUpperCase().includes(busca.toLocaleUpperCase());
  });

  return (
    <MobileLayout
      headerTitle={
        user?.type === "admin" || user?.isAdmin
          ? "Gerenciamento de Módulos"
          : "Módulos de Aula"
      }
      headerType={
        user?.type === "admin" || user?.isAdmin ? "manager" : "private"
      }
    >
      <Main>
        <div className="search">
          <Input
            placeholder="Digite um termo para buscar"
            size="large"
            value={busca}
            onChange={(e: { target: { value: SetStateAction<string> } }) => {
              setBusca(e.target.value);
            }}
            style={{ width: "70%", height: "5rem" }}
          />
          {(user?.type === "admin" || user?.isAdmin) && (
            <Button
              type="primary"
              style={{
                width: "20%",
                border: "none",
                textAlign: "center",
                height: "5rem",
                borderRadius: "0.8rem",
                backgroundColor: "var(--color-secondary)",
                textEmphasisColor: "white",
              }}
              onClick={() => navigate("/new-module")}
            >
              +Adicionar
            </Button>
          )}
        </div>
        <Divider />
        <div className="boxList">
          {modulesWithSearch.map((d) => (
            <Card
              key={d.uid}
              style={{ marginTop: "10px", paddingTop: "10px" }}
              cover={
                <img
                  alt="example"
                  style={{ width: "220px", height: "150px", display: "flex" }}
                  src={d?.tumblr}
                />
              }
              actions={[
                <div
                  key="actions"
                  className="d"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "0 2rem",
                  }}
                >
                  <Button
                    type="primary"
                    onClick={() =>
                      navigate(`/modulesDetails/`, {
                        state: {
                          id: d.uid,
                          title: d.title,
                          tumblr: d.tumblr,
                          description: d.description,
                          dados: d.dados,
                        },
                      })
                    }
                  >
                    Detalhar módulo
                  </Button>

                  {(user?.type === "admin" || user?.isAdmin) && (
                    <Popconfirm
                      title="Deseja realmente apagar o módulo?"
                      okText="Sim"
                      cancelText="Não"
                      onConfirm={() => deleteModule(d.uid)}
                    >
                      <Button style={{ borderColor: "red" }}>
                        <DeleteOutlined style={{ color: "red" }} />
                      </Button>
                    </Popconfirm>
                  )}
                </div>,
              ]}
            >
              <Meta title={d.title} />
            </Card>
          ))}
          <span style={{ width: "270px" }} />
        </div>
      </Main>
    </MobileLayout>
  );
}

export default Modules;
